import * as React from 'react';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';

export default function SearchableDropdown({label, list, onChange, value, ...rest}) {

  const selectedOption = list.find(option => option.id === parseInt(value));
  return (
    <Autocomplete
    id="combo-box-demo"
    sx={{ width: 'auto' }}
    size='small'
    options={list}
    getOptionLabel={(option) => option.name}
    onChange={onChange}
    value={selectedOption || null }
    renderInput={(params) => <TextField {...params} label={label} />}
    
  />
  );

  
}
